import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

export default function Welcome() {
  const navigate = useNavigate();
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext('2d');
    let animId;
    let W = canvas.width = window.innerWidth;
    let H = canvas.height = window.innerHeight;

    const dots = Array.from({ length: 80 }, () => ({
      x: Math.random() * W, y: Math.random() * H,
      r: Math.random() * 3 + 1,
      dx: (Math.random() - 0.5) * 0.5,
      dy: (Math.random() - 0.5) * 0.5,
      o: Math.random() * 0.5 + 0.2,
    }));

    function draw() {
      ctx.clearRect(0, 0, W, H);
      dots.forEach(d => {
        d.x += d.dx; d.y += d.dy;
        if (d.x < 0 || d.x > W) d.dx *= -1;
        if (d.y < 0 || d.y > H) d.dy *= -1;
        ctx.beginPath();
        ctx.arc(d.x, d.y, d.r, 0, Math.PI * 2);
        ctx.fillStyle = `rgba(215,38,56,${d.o})`;
        ctx.fill();
      });
      animId = requestAnimationFrame(draw);
    }
    draw();

    const onResize = () => {
      W = canvas.width = window.innerWidth;
      H = canvas.height = window.innerHeight;
    };
    window.addEventListener('resize', onResize);
    return () => { cancelAnimationFrame(animId); window.removeEventListener('resize', onResize); };
  }, []);

  function choose(path) {
    localStorage.setItem('ptm_welcome_seen', '1');
    navigate(path);
  }

  return (
    <div style={{ position: 'relative', minHeight: '100vh', backgroundColor: '#080808', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'space-between', padding: '0 24px', overflow: 'hidden' }}>

      <canvas ref={canvasRef} style={{ position: 'absolute', inset: 0, pointerEvents: 'none' }} />
      <div style={{ position: 'absolute', top: -160, left: '50%', transform: 'translateX(-50%)', width: 600, height: 600, borderRadius: '50%', background: 'radial-gradient(circle, rgba(215,38,56,0.25) 0%, transparent 70%)', pointerEvents: 'none' }} />

      <div style={{ position: 'relative', zIndex: 1, flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', width: '100%', maxWidth: 400, paddingBottom: 40 }}>

        {/* Logo — large, no text */}
        <div style={{ marginBottom: 56 }}>
          <img
            src="/icons/Win_R_Logo.png"
            alt="Win/R"
            style={{ width: '100%', maxWidth: 300, objectFit: 'contain', display: 'block', margin: '0 auto', filter: 'drop-shadow(0 0 40px rgba(215,38,56,0.4))' }}
          />
        </div>

        {/* Buttons */}
        <div style={{ width: '100%', display: 'flex', flexDirection: 'column', gap: 16 }}>

          <button onClick={() => choose('/register')} style={{
            width: '100%', padding: '20px 22px', borderRadius: 16,
            background: '#D72638', border: 'none',
            color: '#fff', cursor: 'pointer', fontFamily: 'inherit',
            textAlign: 'left',
            boxShadow: '0 4px 24px rgba(215,38,56,0.35)',
            transition: 'opacity 0.15s, transform 0.15s',
          }}
            onMouseEnter={e => { e.currentTarget.style.opacity = '0.92'; e.currentTarget.style.transform = 'translateY(-2px)'; }}
            onMouseLeave={e => { e.currentTarget.style.opacity = '1'; e.currentTarget.style.transform = 'translateY(0)'; }}>
            <div style={{ fontSize: 15, fontWeight: 700, marginBottom: 6, letterSpacing: 0.1 }}>I'm a Trainer →</div>
            <div style={{ fontSize: 12, lineHeight: 1.6, opacity: 0.82, fontWeight: 400 }}>
              Manage your business end-to-end — schedule sessions, track client progress, build custom programs, send invoices, and grow your client base from one place.
            </div>
          </button>

          <button onClick={() => choose('/client-register')} style={{
            width: '100%', padding: '20px 22px', borderRadius: 16,
            background: 'rgba(255,255,255,0.05)',
            border: '1px solid rgba(255,255,255,0.1)',
            color: '#fff', cursor: 'pointer', fontFamily: 'inherit',
            textAlign: 'left',
            transition: 'background 0.15s, transform 0.15s',
          }}
            onMouseEnter={e => { e.currentTarget.style.background = 'rgba(255,255,255,0.08)'; e.currentTarget.style.transform = 'translateY(-2px)'; }}
            onMouseLeave={e => { e.currentTarget.style.background = 'rgba(255,255,255,0.05)'; e.currentTarget.style.transform = 'translateY(0)'; }}>
            <div style={{ fontSize: 15, fontWeight: 700, marginBottom: 6, letterSpacing: 0.1 }}>Join the Community →</div>
            <div style={{ fontSize: 12, lineHeight: 1.6, opacity: 0.6, fontWeight: 400 }}>
              Find accountability partners, schedule workouts with friends, share your fitness journey, discover inspiration, and stay consistent with a community that keeps you moving.
            </div>
          </button>

        </div>

      </div>

      <p style={{ position: 'relative', zIndex: 1, fontSize: 11, color: '#2A2A2A', marginBottom: 20, letterSpacing: 1, textTransform: 'uppercase' }}>
        Built by ImagiSoft Ltd
      </p>
    </div>
  );
}
